import React from "react";
import "./resume.css";

import {
  FaPhoneAlt,
  FaWhatsapp,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";

const Resume = () => {
  const iconColor = "#0f8f84";

  return (
    <div className="resume-container">
      <header className="resume-header">
        <h1>Sumit Kumar</h1>
        <p className="position">Lead Engineer</p>
      </header>

      <section className="contact">
        <h3>Contact</h3>

        <div className="d-flex gap-4 flex-wrap">
          <p>
            <FaPhoneAlt color={iconColor} style={{ marginRight: "8px" }} />
            <strong>Phone:</strong>{" "}
            <a href="tel:+918093512506">+91-809-351-2506</a>
          </p>

          <p>
            <FaWhatsapp
              color={iconColor}
              style={{ marginRight: "8px", color: "green" }}
            />
            <strong>WhatsApp:</strong>{" "}
            <a
              href="https://wa.me/918603592692"
              target="_blank"
              rel="noopener noreferrer"
            >
              +91-860-359-2692
            </a>
          </p>
          
        </div>

        <div className="d-flex gap-4 flex-wrap mt-2">
          <p>
            <FaEnvelope color={iconColor} style={{ marginRight: "8px" }} />
            <strong>Email:</strong>{" "}
            <a href="mailto:sumit.raipura@gmail.com">sumit.raipura@gmail.com</a>
          </p>

          <p>
            <FaMapMarkerAlt color={iconColor} style={{ marginRight: "8px"}} />
            <strong>Address:</strong> WhiteField, Bengaluru
          </p>

        </div>
      </section>

      <section className="experience">
        <h3>Professional Experience</h3>

        <div className="job">
          <h4>ALTEN India (Airbus)</h4>
          <p>
            <em>Lead Engineer | May 2022 - Present, Bengaluru</em>
          </p>
          <ul>
            <li>
              Developed modern, responsive UI components using React.js and
              Airbus Design System.
            </li>
            <li>
              Participated in Agile/Scrum ceremonies and maintained feature
              delivery timelines.
            </li>
            <li>
              Led redesign of legacy frontend modules improving performance by
              25%.
            </li>
          </ul>
        </div>

        <div className="job">
          <h4>Simulanis Solution</h4>
          <p>
            <em>Application Developer | August 2018 – April 2022, Noida</em>
          </p>
          <ul>
            <li>
              Built web apps with React for dashboards and data visualization.
            </li>
            <li>
              Developed and deployed 3D applications using Unity 3D for desktop
              and mobile.
            </li>
            <li>
              Simulated real-world behaviors for training in industrial domains.
            </li>
          </ul>
        </div>
      </section>
      <section className="education">
        <h3>Education</h3>
        <p>
          <strong>National Institute of Science & Technology</strong>
        </p>
        <p>B.Tech in Computer Science & Engineering | 2014–2018</p>
      </section>
      <section className="skills">
        <h3>Skills</h3>
        <ul className="skills-list">
          <li>React.js</li>
          <li>JavaScript</li>
          <li>TypeScript</li>
          <li>Git</li>
          <li>GitHub</li>
          <li>AWS (EC2, S3, Lambda)</li>
          <li>Terraform (Basic)</li>
          <li>Jenkins</li>
          <li>Scrum & Agile</li>
          <li>Unity 3D & C#</li>
          <li>Python (Basic)</li>
          <li>Firebase</li>
          <li>Play Store Publishing</li>
        </ul>
      </section>
      <section className="achievements">
        <h3>Achievements</h3>
        <ul>
          <li>Godrej Interio | 2019 - Simulanis Solution Pvt Ltd</li>
          <li>HMEL | 2020 - Simulanis Solution Pvt Ltd</li>
          <li>Godrej Configurator | 2021 - Simulanis Solution Pvt Ltd</li>
          <li>Pinnacle Achiever Award | 2023 - ALTEN India</li>
        </ul>
      </section>
      <a
        href="https://drive.google.com/uc?export=download&id=1CP3EyHCHxufSs9HhuyDYKQGjo-tyVTlA"
        download="Sumit_Kumar_Resume.pdf"
        className="download-btn"
      >
        Download PDF
      </a>
    </div>
  );
};

export default Resume;
